import type { Invite } from "@shyne/shared/api";
import { api } from "@/lib/api";
import {uuid} from "@/interfaces";
import {store} from "@/lib/store.ts";

export const InviteRepository = {
    async inviteVendor(email: string): Promise<{ alreadyOnboarded: boolean }> {
        const inviter = store.getState().organization.activeOrgId;
        if (!inviter) throw new Error("No active organization");
        const { outcome } = await api.invites.send(inviter, { kind: "vendor", email });
        return { alreadyOnboarded: outcome === "linked" };
    },

    async readInvite(token: uuid): Promise<Invite> {
        return api.invites.read(token);
    },

    async acceptVendorRelationshipInvite(token: uuid): Promise<void> {
        await api.invites.acceptVendorRelationship(token);
    },

    async declineVendorRelationshipInvite(token: uuid): Promise<void> {
        await api.invites.declineVendorRelationship(token);
    }
}
